import * as React from "react";
import { useUserContext } from "../../../context";
import { addHours, addMinutes, getHours } from "date-fns";

export function WelcomeSection() {
  const { userdetails } = useUserContext();

  // Get the current hour to customize the greeting
  const now = new Date();

  // Add IST offset: 5 hours 30 minutes
  const istDate = addMinutes(addHours(now, 5), 30);

  const currentHourIST = getHours(istDate);
  const greeting =
    currentHourIST >= 5 && currentHourIST < 12
      ? "Good Morning"
      : currentHourIST >= 12 && currentHourIST < 18
        ? "Good Afternoon"
        : "Good Evening";

  return (
    <div className="flex flex-col w-full max-md:max-w-full">
      <div className="text-2xl font-semibold leading-none text-darkMode-text">
        {userdetails?.name ? (
          <h1 className="text-4xl md:text-5xl font-bold mb-2">
            Welcome{" "}
            <span className="text-market-teal"> {userdetails.name}</span>
          </h1>
        ) : (
          "Welcome to the Dashboard!"
        )}
      </div>
      <div className="mt-2 text-sm leading-none text-darkMode-subText">
        {userdetails?.name
          ? "We're excited to help you find momentum stocks today."
          : "Please log in to access personalized recommendations."}
      </div>
    </div>
  );
}
